module.exports = __webpack_public_path__ + "img/currency-info.932bdd68.svg";